import React, { useState } from 'react'
import Question from './Question';
import { Link } from 'react-router-dom';
import { Trans } from '@ui/i18n/trans';

const data: { question: string, answer: string }[] = [
    { question: 'What is Candy Cloudy?', answer: 'Candy Cloudy is a secure, cloud-based platform that lets you store, view, and even edit your files from anywhere.' },
    { question: 'How do I add my files to Candy Cloudy?', answer: 'Simply log in, upload your files through our easy-to-use interface, and they’ll be safely stored in your personal cloud space.' },
    { question: 'What types of files can I work with?', answer: 'Candy Cloudy supports a wide range of file types, including documents, spreadsheets, presentations, images, and more.' },
    { question: 'Can I share my files with others?', answer: 'Yes, you can quickly share files or folders with colleagues, friends, or clients, and set permissions based on whether you want them to view or edit.' },
    { question: 'Is my data secure with Candy Cloudy?', answer: 'Absolutely. We prioritize your privacy and protect your files using robust security measures to ensure that only you and those you trust have access.' },
    { question: 'Can I edit my documents directly in Candy Cloudy?', answer: 'Yes, you can open and edit your documents right within the platform, making it easy to update your files without switching between apps.' },
    { question: 'How customizable is the Candy Cloudy experience?', answer: 'Candy Cloudy is designed to adapt to your needs, allowing you to personalize settings and manage your files in a way that best suits your workflow.' }
];


export default function Faq() {

    const [activeQuestion, setActiveQuestion] = useState('');

    return (
        <div className='py-80 px-10 lg:px-80'>
            <h2 className='text-black text-center dark:text-white text-5xl md:text-[56px] font-semibold'>
                <Trans message="Frequently asked" /><br />
                <span className='text-gradient-pink'><Trans message="questions" /></span>
            </h2>
            <p className='text-center text-[#888888] text-lg mt-32 mb-64'>
                <Trans message="Everything you need to know about the product and billing." />
            </p>
            <div className='flex flex-col items-center w-full gap-32'>
                {data.map((question, idx) => (
                    <div key={question.question} className={`${idx > 0 ? 'pt-24 border-t-1 border-t-[#EAEBF0]' : ''}`}>
                        <Question
                            question={question.question}
                            answer={question.answer}
                            activeQuestion={activeQuestion}
                            setActiveQuestion={setActiveQuestion}
                        />
                    </div>
                ))}
            </div>
            <div className='w-full p-32 rounded-[16px] bg-[#FAFAFB] dark:bg dark:border mt-64'>
                <h3 className='text-darkBlue dark:text-white text-center font-semibold text-xl'>
                    <Trans message="Still have questions?" />
                </h3>
                <p className='text-center text-lg text-[#888888]'>
                    <Trans message="Can’t find the answer you’re looking for? Please chat to our friendly team." />
                </p>
                <Link to={'/contact'} className='bg-primary py-12 px-20 rounded-[8px] text-center block mx-auto mt-32 text-white w-fit'>
                    <Trans message="Get in touch" />
                </Link>
            </div>
        </div>

    )
}
